import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { basicInfoForm } from 'FormDefinitions/BasicInfoForm/BasicInfoFormDefinition'
import AppForm from 'components/Form/AppForm/AppForm'
import AppConsent from 'components/Consents/AppConsents/AppConsent'
import { AppDispatch, AppState } from 'store'
import useAppFormLogic from 'components/Form/AppForm/hooks/useAppFormLogic'


/**
 * Pierwsza strona formularza zbierająca podstawowe informacje o użytkowniku oraz zgody
*/
const BasicInfoForm = (): JSX.Element => {

   const dispatch = useDispatch<AppDispatch>()
   const appConsents = useSelector((state: AppState) => state.consentsState.appConsents)
   const { handleBasicInfoFormSubmitButtonClick } = useAppFormLogic({ form: basicInfoForm })


   return (
      <>
         <AppForm form={basicInfoForm} handleSubmitButtonClick={(e: React.SyntheticEvent) => handleBasicInfoFormSubmitButtonClick(e, appConsents)} >
            <AppConsent />
         </AppForm>
      </>
   )
}

export default BasicInfoForm